import React, { FC, useContext, useState } from 'react';
import { SimpleHeader as SimpleHeaderComponent } from '@agria/theme/src/components/headers/simpleHeader/SimpleHeader';
import { useSiteMetadata } from '@agria/theme/src/hooks/useSiteMetadata';
import { siteLinks } from '@agria/theme/src/const/siteLinks';
import { ExperimentsContext } from '@agria/theme/src/context/ExperimentsContext';
import { TrustpilotStarsWithReviews } from '@agria/theme/src/components/trustpilotStarsWithReviews/TrustpilotStarsWithReviews';

export interface HeaderProps {
  pathname?: string; // The current page pathname, used to determine if Trustpilot should be shown on the first page.
}

export const Header: FC<HeaderProps> = ({ pathname }) => {
  const { contactNumber, companyName } = useSiteMetadata();
  const { experiments } = useContext(ExperimentsContext);

  const [initialAgria126] = useState(() => {
    if (typeof window !== 'undefined' && window.experiments?.AGRIA126) {
      return window.experiments.AGRIA126;
    }
    return process.env.GATSBY_EXPERIMENT_AGRIA126;
  });

  const agria126 = experiments?.AGRIA126 ?? initialAgria126;
  const isAGRIA126Variation = agria126 === 'variation';

  const isFirstPage = pathname === '/' || pathname === '';
  const shouldShowTrustpilot = isAGRIA126Variation && isFirstPage;

  return (
    <SimpleHeaderComponent
      companyName={companyName}
      contactNumber={contactNumber}
      logoLink={siteLinks.brochureware}
      centerContent={
        shouldShowTrustpilot ? <TrustpilotStarsWithReviews /> : undefined
      }
    />
  );
};

export default Header;
